import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  List,
  ListItem,
  ListIcon,
  Box,
  Tooltip,
  Link,
  useMediaQuery,
  Flex,
} from "@chakra-ui/react";
import { RiBarChartFill, RiLayoutMasonryFill } from "react-icons/ri";
import { BsPeopleFill, BsPersonFill } from "react-icons/bs";
import { shouldUseMitoRed } from "../../utils/mitoBrand";
import RouteLink from "../../components/form-element/RouteLink";
import { logout } from "../../redux/modules/auth";
import { goToPublicHome, markPublicLogout } from "../../utils/restoreAuthSession";
import { flushAccount } from "../../redux/modules/account";
import { flushKYC } from "../../redux/modules/kyc";
import { BellIcon } from "@chakra-ui/icons";
import {
  resetAmountData,
  resetTransaction,
} from "../../redux/modules/transactions";
import AppLink from "../../components/AppLink";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { FaTimes } from "react-icons/fa";
import { MdOutlineArticle } from "react-icons/md";
import { HiOutlineGift } from "react-icons/hi";
import { rewardsProductOn } from "../../utils/rewardsGate";
import { Icon } from "@chakra-ui/react";
import { ReactComponent as Support } from "../../assets/images/Vector2.svg";
import { ReactComponent as Compliance } from "../../assets/images/Vector3.svg";
import { ReactComponent as Settings } from "../../assets/images/Vector4.svg";
import { ReactComponent as LogOut } from "../../assets/images/Vector5.svg";

const SidebarMenuListitems = (props: any) => {
  const { isSidebarCollapased } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { kycStarted, user, tenancyConfigData, Notifications } = useAppSelector(
    (state: any) => ({
      kycStarted: state.kyc.kycStarted,
      user: state.account.userData,
      tenancyConfigData: state.affiliate.multiTenancyConfigData,
      Notifications: state.account.Notifications,
    }),
  );
  const [isNotificationCount, setIsNotificationCount] = useState(0);

  useEffect(() => {
    const getNotificationCount = (
      Array.isArray(Notifications) ? Notifications : []
    ).filter(
      (notification: any) => notification.type === "SupportTicket",
    ).length;
    setIsNotificationCount(getNotificationCount);
  }, [Notifications]);

  let navigate = useNavigate();
  let location = useLocation();
  let dispatch = useAppDispatch();
  const [isMobile] = useMediaQuery("(max-width: 767px)");

  const menus = useMemo(() => {
    const items: { id: number; icon: any; title: string; path: string }[] = [
    {
      id: 1,
      icon: RiLayoutMasonryFill,
      title: "Overview",
      path: "/overview",
    },
    {
      id: 2,
      icon: RiBarChartFill,
      title: "Transactions",
      path: "/transactions",
    },
    ];
    if (rewardsProductOn(tenancyConfigData)) {
      items.push({
        id: 21,
        icon: HiOutlineGift,
        title: "Reward$",
        path: "/rewards",
      });
    }
    items.push({
      id: 3,
      icon: BsPersonFill,
      title: "Recipients",
      path: "/beneficiaries",
    });
    if (shouldUseMitoRed(tenancyConfigData)) {
      items.push({
        id: 31,
        icon: BsPeopleFill,
        title: "Senders",
        path: "/senders",
      });
    }
    items.push(
    {
      id: 4,
      icon: Compliance,
      title: "Compliance",
      path: "/compliance",
    },
    {
      id: 5,
      icon: Support,
      title: "Support",
      path: "/support",
    },
    {
      id: 8,
      icon: MdOutlineArticle,
      title: "MitoView",
      path: "/mitoview",
    },
    {
      id: 7,
      icon: BellIcon,
      title: "Notifications",
      path: "/notifications",
    },
    {
      id: 6,
      icon: Settings,
      title: "Settings",
      path: "/settings",
    },
    );
    return items;
  }, [tenancyConfigData]);

  const logoutUser = () => {
    markPublicLogout();
    dispatch(logout());
    dispatch(flushAccount());
    dispatch(flushKYC());
    dispatch(resetTransaction());
    dispatch(resetAmountData());
    goToPublicHome();
  };

  return (
    <Box pos="relative">
      {isMobile && !tenancyConfigData.isFrame && (
        <Flex pt="7" justifyContent={"flex-end"}>
          <Icon
            as={FaTimes}
            fontSize={"24px"}
            bg="#9B9B9B"
            p="2"
            color={"white"}
            borderRadius={"100%"}
          />
        </Flex>
      )}
      <List
        variant="SideBar"
        mt={tenancyConfigData.isFrame && "3.2rem"}
        w="100%"
        className="sidebarlist"
      >
        {menus.map((menu) => (
          <Tooltip
            isDisabled={isSidebarCollapased}
            placement="bottom"
            label={menu.title}
            key={menu.id}
          >
            <ListItem
              whiteSpace="nowrap"
              role="group"
              pos="relative"
              key={menu.id}
              style={{ pointerEvents: kycStarted ? "none" : "auto" }}
              color={`${
                location.pathname.includes(menu.path)
                  ? "var(--dynamicPrimaryColor)"
                  : "var(--dynamicNavBarColor)"
              }`}
              fill={`${
                location.pathname.includes(menu.path)
                  ? "var(--dynamicPrimaryColor)"
                  : "var(--dynamicNavBarColor)"
              }`}
              fontWeight={`${
                location.pathname.includes(menu.path) ? "500" : "300"
              }`}
            >
              <AppLink href={menu.path}>
                <ListIcon
                  as={menu.icon}
                  className={`${
                    location.pathname.includes(menu.path) ? "active" : ""
                  }`}
                  fill={`${
                    location.pathname.includes(menu.path)
                      ? "var(--dynamicPrimaryColor)"
                      : "var(--dynamicNavBarColor)"
                  }`}
                  width={"20px"}
                  height={"20px"}
                />
              </AppLink>
              <RouteLink
                className="sideNav_headings"
                to={menu.path}
                text={menu.title}
              />
              {menu.title === "Notifications" &&
                Notifications?.length > 0 &&
                isSidebarCollapased && (
                  <Box className="sidebar-notification">
                    <BellIcon
                      w={10}
                      margin="auto"
                      height="full"
                      padding="1px"
                    />{" "}
                    <span className="notification-count">
                      {Notifications.length}
                    </span>
                  </Box>
                )}
              {menu.title === "Support" &&
                isNotificationCount > 0 &&
                isSidebarCollapased && (
                  <Box className="sidebar-notification">
                    <BellIcon
                      w={10}
                      margin="auto"
                      height="full"
                      padding="1px"
                    />{" "}
                    <span className="notification-count">
                      {isNotificationCount}
                    </span>
                  </Box>
                )}
            </ListItem>
          </Tooltip>
        ))}
        {isMobile && !tenancyConfigData.isFrame && (
          <Box
            py="10"
            borderTop="1px"
            borderBottom="1px"
            mb="10"
            borderColor={"#E1DFDD"}
          >
            {/* <ListItem
                role="group"
                onClick={() => navigate("#")}
                style={{pointerEvents: kycStarted ? "none": 'auto'}}
                color="var(--dynamicNavBarColor)"
              >
                <Link className="sideNav_headings">How it Works</Link>
            </ListItem> */}
            <ListItem
              role="group"
              onClick={() => navigate("/faq")}
              style={{ pointerEvents: kycStarted ? "none" : "auto" }}
              color="var(--dynamicNavBarColor)"
            >
              <Link className="sideNav_headings">FAQ</Link>
            </ListItem>
            <ListItem
              role="group"
              onClick={() => navigate("/contact")}
              style={{ pointerEvents: kycStarted ? "none" : "auto" }}
              color="var(--dynamicNavBarColor)"
              mb="0"
            >
              <Link className="sideNav_headings">Help</Link>
            </ListItem>
          </Box>
        )}
        <Tooltip
          isDisabled={isSidebarCollapased}
          placement="bottom"
          label="Logout"
        >
          <ListItem
            role="group"
            onClick={logoutUser}
            whiteSpace="nowrap"
            key="6"
            style={{ pointerEvents: kycStarted ? "none" : "auto" }}
            color="var(--dynamicNavBarColor)"
          >
            <ListIcon as={LogOut} fill="var(--dynamicNavBarColor)" />
            <Link className="sideNav_headings">Logout</Link>
          </ListItem>
        </Tooltip>
      </List>
    </Box>
  );
};

export default React.memo(SidebarMenuListitems);
